// Marketing configuration documents (greeting, CTA, page rules, conversions, integrations) are
// stored per tenant as one JSON document per section.
import { apiClient } from "../apiClient";

/** Resolves to the saved doc, or null when the section was never saved (UI falls back to its defaults). */
export const getMarketingDoc = (section) => apiClient(`/api/marketing/${section}`).then((res) => res.data.doc);
export const saveMarketingDoc = (section, doc) =>
  apiClient(`/api/marketing/${section}`, { method: "PUT", body: JSON.stringify({ doc }) }).then((res) => res.data.doc);
